import React, { useState } from 'react'
import Navbar from '../../components/Navbar'
import IndustriesImageContainer from '../../components/IndustriesImageContainer'
import Footer from '../../components/Footer'
import { useTranslation } from 'react-i18next'
import { DoubleCustomBreadCrumbs } from '../../components/CustomBreadcrumbs';
import HomeTabCarousel from './../Home/HomeTabCarousel';
import about_us from "../../assets/images/contents/about-us-content.png"
import fa_thin_arrow_down from "../../assets/images/icons/fa-thin-arrow-down-white.svg"
import fa_thin_arrow_up from "../../assets/images/icons/fa-thin-arrow-up-white.svg"
import AboutTimeline from './AboutTimeline'
import { useSelector } from 'react-redux'
import { selectLanguage } from '../../redux/language/selector'

const AboutUs = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const language = useSelector(selectLanguage)

  const { t } = useTranslation()
  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className='about-us bg-primary'>
      <Navbar />
      <div className='container-fluid about-us-header pb-100'>
        <div className='container'>
          <div className='col-sm-12 pt-lg-270 pt-200'>
            <p className='font-weight-bold text-center font-96 about-us-header-title uppercase'>{t('about-us.title')}</p>
          </div>
          <div className='col-sm-12 flex justify-center pt-150'>
          </div>
        </div>
      </div>
      <div className='container'>
        <div className='col-sm-12 flex justify-center pt-20'>
          <DoubleCustomBreadCrumbs currentPage={t('bread-crumbs.about-us')} />
        </div>
      </div>
      <div className='about-us-content container pt-100'>
        <div className="col-xl-6">
          <img src={about_us} alt="" className='img-responsive mt-20' />
        </div>
        <div className="col-xl-6">
          <div className='qrypto-story'>
            {language === "en"
            ?
            <p className='text-white font-45 font-weight-semi-bold'><span className='text-primary-orange'>Qrypto</span> Story</p>
            :
            <p className='text-white font-45 font-weight-semi-bold'>Câu chuyện về <span className='text-primary-orange'>Qrypto</span></p>
            }
            <div className={`qrypto-story_content pt-30 ${isExpanded ? "active" : ""}`} >
              <p>{t('about-us.qrypto-story.content-1')}</p>
              <p className='pt-20'>{t('about-us.qrypto-story.content-2')}</p>
              <p className='pt-20'>{t('about-us.qrypto-story.content-3')}</p>
              <p className='pt-20'>{t('about-us.qrypto-story.content-4')}</p>
              <p className='pt-20'>{t('about-us.qrypto-story.content-5')}</p>
              <p className='pt-20'>{t('about-us.qrypto-story.content-6')}</p>
            </div>
            <div className='read-more-btn' onClick={toggleExpanded}>
              <div className='flex gap-5 justify-center'>
                <p className='font-weight-semi-bold'>{!isExpanded ? t('button.read-more') : t("button.read-less")}</p>
                {!isExpanded ? <img src={fa_thin_arrow_down} alt="" /> : <img src={fa_thin_arrow_up} alt="" />}
              </div>
            </div>
          </div>
        </div>
        <div className='col-sm-12 pt-100'>
          {/* <AboutUsAchivement/> */}
          <AboutTimeline/>
        </div>
      </div>
      <HomeTabCarousel />
      <div className='container'>
        <IndustriesImageContainer />
      </div>
      <Footer />
    </div>
  )
}

export default AboutUs